var animations = {};

animations.init = function ($root) {
    addAnimationEvent();
}

animations.stop = function ($root) {
    stopAnimOnPageChange();
}





var loadedAnims = [];

function playAnimation(anim_id) {
    var $qAnim = $("#" + anim_id);
    $qAnim.quadroAnim({
        jsonUrl: '../json/' + anim_id + '.json',
        imagesLoaded: function() {
            $("#" + anim_id).find('.fake').remove();
        },
        media_locators: {
            media_lib_path: '../data-images-smeg/animations',
            media_anim_path: '../data-images-smeg/animations'
        }, 
        playAuto: true
    });
    loadedAnims[anim_id] = $qAnim;
}

function loadThisAnim(div) {
    var pClass = div.parentNode.className;
    var fake = div.getElementsByClassName("fake")[0];
    if ( fake ) {
        fake.removeChild(fake.getElementsByClassName("play")[0]);
        fake.removeChild(fake.getElementsByClassName("track")[0]);
        div.parentNode.className = pClass.replace("animContainer","");
        playAnimation(div.id);
    }
}

function stopAnimOnPageChange() {
    for ( var anim in loadedAnims ) {
        try {
            loadedAnims[anim].quadroAnim("stop");
        } catch(e) {
            console.log('Error on page change ');
        }
    }
    loadedAnims = [];
}

function addAnimationEvent() {
    var anims = document.getElementsByClassName("divToAnim");
    for ( var i = 0; i < anims.length; i++ ) {
        anims[i].addEventListener("click", function(e) {
            var div = e.srcElement;
            while ( div.className.indexOf("divToAnim") == -1 ) {
                div = div.parentNode;
            }
            loadThisAnim(div);
        }, false);
    }
}
